import { render, staticRenderFns } from "./RetardForm.vue?vue&type=template&id=378dadc1"
import script from "./RetardForm.vue?vue&type=script&lang=js"
export * from "./RetardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports